import styled from 'styled-components';

export const DetailHotelInfoMainWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        flex-direction: column;
        background-color: ${props.theme.colors.white.base};
        box-shadow: 0 3px 30px 0 ${props.theme.colors.black.light1};
        border-radius: ${props.theme.misc.borderRadius.xxlarge};
        padding: ${props.theme.spacing.large.l20};
    `
);

export const HotelInfoTop = styled.div(
    props => `
        width: 100%;
        display: flex;
        justify-content: space-between;

    `
);

export const HotelInfoWrap = styled.div(
    props => `
        width: 73%;
        display: flex;
        flex-direction: column;  
    `
);

export const HotelDetailText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.black.base};
        line-height: ${props.theme.font.lineHeight.large};
        padding-top: ${props.theme.spacing.large.l12};
        a{
            color: ${props.theme.colors.blue.base};
            font-weight: ${props.theme.font.fontWeight.bold};
            &:hover{
                color: ${props.theme.colors.blue.base};
            }
        }
    `
);

export const HotelPoliciesWrap = styled.div(
    props => `
        width:30rem;
        display: flex;
        flex-direction: column;
        border-left: 1px dashed ${props.theme.colors.grey.lightdd};
        padding-left: ${props.theme.spacing.base};
    `
);


export const RulesHeadWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        flex-direction: column;
    `
);

export const RulesHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};  
    `
);

export const CheckInOutWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        padding-top: ${props.theme.spacing.small.s3};  
        align-items: center;
    `
);


export const CheckWrap = styled.div(
    props => `
        display: flex;
        align-items: center;
        padding-right: ${props.theme.spacing.large.l25};  
    `
);

export const CheckText = styled.p(
    props => `
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.grey.base};
        padding-right: ${props.theme.spacing.small.s5}
    `
);

export const CheckTimeText = styled.p(
    props => `
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.grey.base};  
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const MandatoryTag = styled.div(
    props => `
        width:100%;
        display: flex;
        background-color: ${props.theme.colors.yellow.bgYellow};
        padding: ${props.theme.spacing.small.s7} ${props.theme.spacing.base};
        border-radius: ${props.theme.misc.borderRadius.base};
        margin-top: ${props.theme.spacing.small.s8};
    `
);

export const MadatoryText = styled.p(
    props => `
        font-size: ${props.theme.font.small.font12};
        color: ${props.theme.colors.grey.base}; 
        line-height: ${props.theme.font.lineHeight.base};
    `
);

export const PolicyWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        flex-direction: column;
        padding-top: ${props.theme.spacing.large.l15};  
    `
);

export const PolicyListBlock = styled.ul(
    props => `
    padding: ${props.theme.spacing.large.l25};
  `,
  );

export const PolicyListLoaderWrapper = styled.li(
    props => `
    display: flex;
    flex-direction: column;
  `,
);

export const PolicyListItemTextStyled = styled.li(
    props => `
    display: flex;
    font-size: ${props.theme.font.large.font16};
    line-height: 1.4;
    list-style-type: none;
    padding: 0 0 ${props.theme.spacing.large.l15} 0;
    flex-direction: row;
  `,
  );

  export const PolicyTextLoader = styled.li(
    props => `
    display: flex;
    line-height: 1.4;
    list-style-type: none;
    width: 10rem;
    color: red;
    padding: 0 0 ${props.theme.spacing.large.l15} 0;
  `,
  );

export const CheckedIconWrapperStyled = styled.span(
    props => `
    padding: 0 ${props.theme.spacing.large.l15} 0 0;
  `,
);

export const PolicyTextStyled = styled.span`
`;

export const GeneralWrap = styled.div(
    props => `
        width: 100%;
        align-items: center;
        justify-content: space-between;
        display: flex;
        // border-bottom: 1px solid ${props.theme.colors.grey.lightdd};
        padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.nospacing};  
    `
);

export const ChildWrap = styled.div(
    props => `
        width: 100%;
        align-items: center;
        justify-content: space-between;
        display: flex;
        padding-top: ${props.theme.spacing.small.s5};
    `
);

export const GeneralText = styled.a(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.blue.base};
        cursor: pointer;
        &:hover{
            color: ${props.theme.colors.blue.base};
        }
    `
);

export const RightArrowText = styled.div(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.blue.base};
        cursor: pointer;
    `
);













export const HotelTypeTagWrap = styled.div`
  width: 100%;
  display: flex;
  padding-bottom: 1rem;
`;

export const HotelTypeTag = styled.div`
  border-radius: 4px;
  border: solid 1px #5aa0d5;
  background-color: #ffffff;
  padding: 0.5rem 0.9rem;
  display: flex;
`;

export const HotelTypeText = styled.p`
  font-size: 1.1rem;
  color: #0061aa;
  font-weight: bold;
  text-transform: uppercase;
`;


export const HotelNameRatingWrap = styled.div`
  width: 100%;
  display: flex;
`;

export const HotelNameAddressWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const HotelNameWrap = styled.div`
  width: 100%;
  display: flex;
  padding-bottom: 2px;
  align-items: center;
  padding-right: 1.5rem;
`;

export const HotelNameText = styled.p`
  font-size: 2.2rem;
  color: #000000;
  font-weight: 900;
  letter-spacing: -0.49px;
  line-height: 1.3;
  display: flex;
`;

export const HotelStarWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  position: relative;
  padding: 1rem;
`;

export const HotelAddresWrap = styled.div`
  width: 100%;
  display: flex;
`;

export const AddresText = styled.p`
  font-size: 1.2rem;
  letter-spacing: -0.27px;
  color: #4a4a4a;
  padding-right: 0.5rem;
`;






// export const GalleryPrcieOuterWrap = styled.div(
//   props => `
//       width:100%;
//       display: flex;
//       padding-bottom: ${props.theme.spacing.large.l20};  
//       justify-content: space-between;
//   `
// );

// export const DetailBigGallery = styled.div(
//   props => `
//       width: 51.5rem;
//       height: 35rem;
//       display: flex;
//       position: relative;
//   `
// );

// export const GalleryBigImg = styled.img(
//   props => `
//       width: 100%;
//       height:35rem;  
//       object-fit: contain;
//   `
// );

// export const GalleryInfoOverlay = styled.div(
//   props => `
//       width:100%;
//       display: flex;
//       background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
//       height: 7rem;
//       padding: ${props.theme.spacing.large.l20};
//       position: absolute;
//       bottom: 0;
//       left:0;  
//       align-items: flex-end;
//   `
// );

// export const OverlayText = styled.p(
//   props => `
//       font-size: ${props.theme.font.base};
//       color: ${props.theme.colors.white.base};
//       font-weight: ${props.theme.font.fontWeight.bold};
//       text-transform: ${props.theme.font.textTransform.upper};
//   `
// );

// export const LeftIconWrap = styled.div(
//   props => `
//       position: absolute;
//       top: 50%;
//       left: 1rem;
//       transform: translateY(-50%);
//   `
// );

// export const RightIconWrap = styled.div(
//   props => `
//       position: absolute;
//       top: 50%;
//       right: 1rem;
//       transform: translateY(-50%);
//   `
// );

// export const GallerySmallLocationWrap = styled.div(
//   props => `
//       width: 32rem;
//       display: flex;
//       flex-direction: column;
//       justify-content: space-between;
//   `
// );

// export const GallerySmallWrap = styled.div(
//   props => `
//       width: 100%;
//       display: flex;
//       height: 19rem;
//       margin-bottom: ${props.theme.spacing.base};  
//       box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
//       border: solid 0.5px ${props.theme.colors.grey.lightdd};
//   `
// );

// export const GallerySmallImg = styled.img(
//   props => `
//       width: 31.8rem;
//       height: 18.8rem;
//       object-fit: contain;
//   `
// );

// export const LocationTopBlock = styled.div(
//   props => `
//       width: 100%;
//       height: 15rem;  
//       display: flex;
//   `
// );

// export const LocationImage = styled.img(
//   props => `
//       width: 100%;
//       height: 15rem;  
//       cursor: pointer;
//   `
// );

// export const PriceRatingWrap = styled.div(
//   props => `
//       width: 30rem;
//       display: flex;
//       flex-direction: column;
//       justify-content: space-between;
//       border-left: 1px dashed ${props.theme.colors.grey.lightdd};
//       padding-left: ${props.theme.spacing.large.l11};  
//   `
// );

// export const PriceInfoTopBlock  = styled.div(
//   props => `
//       width: 100%;
//       display: flex;  
//       flex-direction: column;
//       margin-bottom: ${props.theme.spacing.base};
//   `
// );

// export const PartnerRateWrap = styled.div(
//   props =>`
//       width: 100%;
//       display: flex;
//       padding: ${props.theme.spacing.small.s7} ${props.theme.spacing.base};
//       box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
//       background-image: linear-gradient(75deg, #f5515f, #9f0469);
//       position: relative;
//       justify-content: space-between;
//       align-items: center;
//       &:before {
//           content: '';
//           position: absolute;
//           bottom: -6px;
//           right: 20px;
//           border-left: 5px solid transparent;
//           border-right: 5px solid transparent;
//           border-top: 6px solid #9f0469;
//       }
// `);

// export const PartnerRateText = styled.p(
//   props => `
//       font-size: ${props.theme.font.large.font16};
//       color: ${props.theme.colors.white.base};
//       font-weight: ${props.theme.font.fontWeight.black};
//       letter-spacing: ${props.theme.font.letterSpacing.base};
// `);

// export const SaveText = styled.p(
//   props => `
//       font-size: ${props.theme.font.small.font10};
//       color: ${props.theme.colors.white.base};
//       font-weight: ${props.theme.font.fontWeight.bold};
//       letter-spacing: ${props.theme.font.letterSpacing.large};
//   `
// );


// export const RoomInfoTopBlock = styled.div(
//   props => `
//       width:100%;
//       display: flex;
//       justify-content: space-between;
//       padding: ${props.theme.spacing.base};
//       border: solid 0.7px ${props.theme.colors.grey.lightdd};
//   `
// );

// export const RoomTypeInfoTop = styled.div(
//   props => `
//       width: 60%;
//       display: flex;
//       flex-direction: column;  
//   `
// );

// export const RoomTypeText = styled.p(
//   props => `
//       font-size: ${props.theme.font.large.font16};
//       color: ${props.theme.colors.black.base};
//       font-weight: ${props.theme.font.fontWeight.black};
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//   `
// );

// export const PaxInfoTextTop = styled.p(
//   props => `
//       font-size: ${props.theme.font.small.font11};
//       color: ${props.theme.colors.grey.base};
//       padding-top: ${props.theme.spacing.small.s3};  
//   `
// );

// export const AmenitesWrapTop = styled.div(
//   props => `
//       width: 100%;
//       display: flex;
//       flex-direction: column;
//       padding-top: ${props.theme.spacing.small.s5};
//   `
// );

// export const AmenitiesInnerWrapTop = styled.div(
//   props => `
//       width: 100%;
//       display: flex;
//       padding-top: ${props.theme.spacing.small.s6};
//   `
// );

// export const TickIconWrapTop = styled.div(
//   props => `
//       width: 1.6rem;
//       height: 1.6rem;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       margin-right: ${props.theme.spacing.small.s8};
//   `
// );

// export const AmenitiesTextWrapTop = styled.div(
//   props => `
//       width:90%;
//       display: flex;
//   `
// );

// export const AmenitesTopText = styled.p(
//   props => `
//       font-size: ${props.theme.font.base};
//       color: ${props.theme.colors.grey.base};
//   `
// );

// export const RoomPriceTop = styled.div(
//   props => `
//       width: 40%;
//       display: flex;
//       flex-direction: column;  
//       align-items: flex-end;
//   `
// );

// export const OriginalPriceTop = styled.p(
//   props => `
//       font-size: ${props.theme.font.base};
//       color: ${props.theme.colors.grey.base};
//       text-decoration: line-through;
//   `
// );

// export const NewPriceTop = styled.p(
//   props => `
//       font-size: ${props.theme.font.large.font18};
//       color: ${props.theme.colors.black.base};
//       letter-sapcing: ${props.theme.font.letterSpacing.large};
//   `
// );

// export const DealWrapTop  = styled.div(
//   props => `
//       width: 90%;
//       display: flex;
//       justify-content: flex-end;
//       padding-top: ${props.theme.spacing.small.s5};  
//   `
// );

// export const DealMainTextTop = styled.p(
//   props => `
//       font-size: ${props.theme.font.small.font11};
//       color: ${props.theme.colors.red.base};
//       line-height: ${props.theme.font.lineHeight.base};
//       text-align: ${props.theme.font.textAlign.right};
//   `
// );

// export const OtherRoomWraoTop = styled.div(
//   props => `
//       width: 100%;
//       display: flex;
//       justify-content: space-between;
//       align-items: center;
//       border: 1px solid ${props.theme.colors.grey.lightdd};
//       padding: ${props.theme.spacing.base};
//   `
// );

// export const OtherRoomText = styled.a(
//   props => `
//       font-size: ${props.theme.font.base};
//       color: ${props.theme.colors.blue.base};
//       font-weight: ${props.theme.font.fontWeight.black};
//       text-transform: ${props.theme.font.textTransform.upper};
//       &:hover{
//           color: ${props.theme.colors.blue.base};
//       }
//   `
// );

// export const BookRoomBtn = styled.a(
//   props => `
//       display: flex;
//       align-items: flex-end;
//       padding: ${props.theme.spacing.small.s8} ${props.theme.spacing.large.l25};
//       box-shadow: 0 1px 7px 0 ${props.theme.colors.black.light2};
//       background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);  
//       text-transform: ${props.theme.font.textTransform.upper};
//       font-size: ${props.theme.font.base};
//       color: ${props.theme.colors.white.base};
//       font-weight: ${props.theme.font.fontWeight.black};
//       border-radius: 3.5rem;
//       &:hover{
//           color: ${props.theme.colors.white.base};
//       }
//   `
// );

// export const RatingTopBlock  = styled.div(
//   props => `
//       width: 100%;
//       display: flex;  
//       flex-direction: column;
//       border: 1px solid ${props.theme.colors.grey.lightdd};
//   `
// );

// export const RatingInfoHeadWrap = styled.div(
//   props => `
//       width: 100%;
//       display: flex;
//       justify-content: space-between;
//       align-items: center;  
//       padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
//       border-bottom: 1px solid ${props.theme.colors.grey.lightdd};
//   `
// );

// export const RatingInfoWrap = styled.div(
//   props => `
//       width: 80%;
//       display: flex;
//       flex-direction: column;  
//   `
// );

// export const UserReviewHeadText = styled.p(
//   props => `
//       font-size: ${props.theme.font.large.font16}
//       color: ${props.theme.colors.grey.base};
//       font-weight: ${props.theme.font.fontWeight.black};  
//   `
// );

// export const BasedText = styled.p(
//   props => `
//       font-size: ${props.theme.font.small.font11}
//       color: ${props.theme.colors.grey.light9b};
//       padding-top: ${props.theme.spacing.small.s2};
//   `
// );

// export const RatingWrap = styled.div(
//   props => `
//       width: 20%;
//       display: flex;
//       justify-content: flex-end;
//   `
// );

// export const AvgRating = styled.p(
//   props => `
//       display: flex;
//       padding: ${props.theme.spacing.small.s6};
//       background-color: ${props.theme.colors.green.base};
//       border-radius: ${props.theme.misc.borderRadius.base};
//       font-size: ${props.theme.font.large.font15};
//       color: ${props.theme.colors.white.base};
//       font-weight: ${props.theme.font.fontWeight.black};  
//   `
// );

// export const RatingBreakUp = styled.div(
//   props => `
//       width: 100%;
//       display: flex;
//       align-items: center;
//       justify-content: space-between;  
//       height:6.3rem;
//       align-items: center;
//   `
// );

// export const BreakupWrap = styled.div(
//   props => `
//       width:30%;
//       display: flex;
//       flex-direction: column;  
//       align-items: center;
//       justify-content: center;
//   `
// );

// export const BreakupAvg = styled.p(
//   props => `
//       font-size: ${props.theme.font.large.font20};
//       color: ${props.theme.colors.grey.base};
//       letter-spacing: ${props.theme.font.letterSpacing.large};
//       font-weight: ${props.theme.font.fontWeight.black};  
//   `
// );

// export const BreakUpText = styled.p(
//   props => `
//       font-size: ${props.theme.font.small.font11};
//       color: ${props.theme.colors.grey.base};
//       letter-spacing: ${props.theme.font.letterSpacing.base};
//       text-transform: ${props.theme.font.textTransform.upper};
//   `
// );